/**
 * Logger that gates verbose output behind NODE_ENV.
 * Errors are always logged; warnings only in non-production.
 */
const isProd = process.env.NODE_ENV === 'production';

export const logWarn = (...args) => {
  if (!isProd) console.warn(...args);
};

export const logError = (...args) => {
  console.error(...args);
};
